export default {"src":"/_next/static/media/cryptopedia_search.b56efd0b.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};